import getRelayEnvironment from '../../../relayClientEnvironment';
import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

function importTradeRewardsLevelUpModal() {
    return import(
        /* webpackChunkName: "TradeRewardsLevelUpModalChunk" */
        '../../../TradeRewardsLevelUpModal/TradeRewardsLevelUpModalRenderer'
    ).then(mod => mod.TradeRewardsLevelUpModalRenderer);
}

export const tradeRewardsLevelUpModalAction = ({ customActionType }) => dispatch => {
    importModuleAndRenderNotification({
        importFunc: importTradeRewardsLevelUpModal,
        containerClassName: 'tradeGeneralOnboardingContainer',
        props: {
            openOnRender: true,
            environment: getRelayEnvironment(),
        },
    });

    return dispatch({ type: customActionType.actionType });
};
